import {
  channel, cdbVersion, SlotCode,
} from '@/constants/ad';
import { osType } from '@/util/other';
import Api from '@/api/ad';
import STATUS from '@/constants/status';

export default {
  namespaced: true,
  state: {
    slotCodeMap: {
      [SlotCode.HOME_BANNER]: null,
      [SlotCode.HOME_MODAL]: null,
      [SlotCode.BILL_BANNER]: null,
    },
  },
  getters: {
    userId(state, getters, rootState) {
      return rootState.billModule.customerId;
    },
    poiId(state, getters, rootState, rootGetters) {
      return rootGetters.poiForWallet;
    },
    getSlotInfoByCode(state) {
      return function (slotCode) {
        return state.slotCodeMap[slotCode];
      };
    },
    getShowSlot(state, getters, rootState, rootGetters) {
      return function (slotCode) {
        const info = getters.getSlotInfoByCode(slotCode);
        if (!info) return false;
        if (slotCode === SlotCode.HOME_MODAL) {
          const arr = ['isNeedToCheckRenewCooperationAgreement', 'isNeedToCheckSubjectChangeAgreement', 'isNeedToCheckKaSupplementAgreement'];
          return arr.every((key) => !rootGetters[`partnerModule/${key}`]);
        } else if (slotCode === SlotCode.BILL_BANNER) {
          return rootGetters.isMerchantOrThirdPartyUser;
        }
        return true;
      };
    },
  },
  mutations: {
    deleteSlotCodeList(state, payload) {
      payload.forEach((slot) => { state.slotCodeMap[slot] = null; });
    },
    setSlotCodeList(state, payload) {
      payload.forEach((slot) => { state.slotCodeMap[slot.slotCode] = slot; });
    },
  },
  actions: {
    async getSlotList({ getters, commit }, payload) {
      commit('deleteSlotCodeList', payload);
      const { poiId, userId } = getters;
      const headers = { cdb_version: cdbVersion, userId };
      const params = {
        channel, slotCodeList: payload, poiId, osType,
      };
      const { code, data } = await Api.getSlotList(params, headers);
      if (Number(code) === STATUS.SUCCESS) {
        commit('setSlotCodeList', (data || []));
      }
    },
  },
};
